import loadable from '@loadable/component';
import qs from 'query-string';
import { fetchFeed } from '../../actions/feed';
import Loading from '../../components/Loader';
import { ActivityType, Scope } from '../../interfaces/Social';
import { State } from '../../reducers';
import { getUserLoginState } from '../../selectors/user';

const Feed = loadable(() => import(/* webpackChunkName: "feed" */ './container'), {
  fallback: Loading
});
/*global SERVER */
Feed.needs = (props, { getState, dispatch }) => {
  if (SERVER) return;
  const state: State = getState();
  const path = [props.params.filter, props.params.subfilter].filter(Boolean).join('/');
  const filter = pathToFilter[path] || {};
  const user = getUserLoginState(state);
  const query = qs.parse(state.router.location.search);
  return Promise.all([
    dispatch(
      fetchFeed({
        ...filter,
        userId: user.id,
        postcode: query.location
      })
    )
  ]);
};

export const pathToFilter = {
  friends: {
    scope: [Scope.FRIENDS]
  },
  neighbours: {
    scope: [Scope.NEIGHBOURS]
  },
  recommendations: {
    filter: [ActivityType.RECOMMENDED_TRADIE]
  },
  'recommendations/friends': {
    scope: [Scope.FRIENDS],
    filter: [ActivityType.RECOMMENDED_TRADIE]
  },
  'recommendations/friends-of-friends': {
    scope: [Scope.FRIENDS_OF_FRIENDS],
    filter: [ActivityType.RECOMMENDED_TRADIE]
  },
  'recommendations/neighbours': {
    scope: [Scope.NEIGHBOURS],
    filter: [ActivityType.RECOMMENDED_TRADIE]
  }
};

export default Feed;
